import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Search, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const CnpjLookupButton = ({ value, onResult, testId = "cnpj-lookup-btn" }) => {
  const [loading, setLoading] = useState(false);
  const digits = String(value || "").replace(/\D/g, "");

  const lookup = async () => {
    if (digits.length !== 14) return toast.error("Digite um CNPJ com 14 dígitos");
    setLoading(true);
    try {
      const { data } = await api.get(`/cnpj/${digits}`);
      onResult(data);
      toast.success(`Dados preenchidos${data.status ? ` — situação: ${data.status}` : ""}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao consultar CNPJ");
    } finally { setLoading(false); }
  };

  return (
    <Button type="button" variant="outline" size="icon" onClick={lookup} disabled={loading}
      title="Buscar dados pelo CNPJ" data-testid={testId}>
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />}
    </Button>
  );
};

export const formatCnpj = (d) => d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
